<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label>Código</label>
      <b-form-input
        type="text"
        placeholder="Código"
        v-model="form.cd"
        name="cd"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('cd')"
        v-if="form.errors.has('cd')"
      ></b-form-feedback>

      <label>Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr"
        name="descr"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('descr')"
        v-if="form.errors.has('descr')"
      ></b-form-feedback>

      <label>Tipo de Área</label>
      <multiselect
            v-model="paramTipoAreaSelected"
            :options="optionsParamTipoArea"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('partparea_id')"
        v-if="form.errors.has('partparea_id')"
      ></b-form-feedback>

      <label>Regiões</label>
      <multiselect
            v-model="regioesSelected"
            :options="optionsRegiao"
            track-by="value"
            label="label"
            :limit="10"
            :multiple="true"
            :clear-on-select="false"
            :hide-selected="true"
            placeholder="Região"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('regioes')"
        v-if="form.errors.has('regioes')"
      ></b-form-feedback>

      <label>Redespacho</label>
      <multiselect
            v-model="redespachoSelected"
            :options-limit="300"
            :limit-text="limitText"
            :options="optionsRedespacho"
            track-by="value"
            label="label"
            id="redespacho"
            :hide-selected="false"
            placeholder="Redespacho ( Digite 3 caracteres para pesquisar )"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :allow-empty="true"
            :loading="isLoadingRedespacho"
            @search-change="listaRedespacho"
          ></multiselect>
      <b-form-feedback v-text="form.errors.get('pessoa_id')"></b-form-feedback>

      <label>Status</label>
      <multiselect
            v-model="statusLivSelected"
            :options="optionsLivStatus"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('status')"
        v-if="form.errors.has('status')"
      ></b-form-feedback>
    </form>

    <label>Pallets</label>
      <multiselect
            v-model="palletsSelected"
            :options="optionsPallet"
            track-by="value"
            label="label"
            :limit="10"
            :multiple="true"
            :clear-on-select="false"
            :hide-selected="true"
            placeholder="Pallet"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('pallets')"
        v-if="form.errors.has('pallets')"
      ></b-form-feedback>

    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: String,
  },
  data() {
    return {
      rota: "area",
      errors_array: [],
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivStatus: [],
      statusLivSelected: [],
      optionsParamTipoArea: [],
      paramTipoAreaSelected: [],
      optionsRegiao: [],
      optionsPallet: [],
      regioesSelected: [],
      palletsSelected: [],
      optionsRedespacho: [],
      redespachoSelected: [],
      isLoadingRedespacho: false,
      form: new Form({
        area_id: "",
        cd: "",
        descr: "",
        partparea_id: "",
        pessoa_id: "",
        regioes: "",
        pallets: "",
        status: 1,
      }),
      helpForm: new Form({search: "", statusRecord: [], params: [] }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd",
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    paramTipoAreaSelected(obj) {
      this.form.partparea_id = obj.value;
    },
    redespachoSelected(obj) {
      this.form.pessoa_id = obj ? obj.value : "";
    },
    statusLivSelected(obj) {
      this.form.status = obj.value;
    },
    regioesSelected(obj) {
      this.form.regioes = obj;
    },
    palletsSelected(obj){
      this.form.pallets = obj;
    }
  },
  mounted() {
    this.getLivStatus();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.area_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.paramTipoAreaSelected = [];
      this.redespachoSelected = [];
      this.statusLivSelected = [];
      this.regioesSelected = [];
      this.palletsSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.paramTipoAreaSelected = [];
      this.redespachoSelected = [];
      this.statusLivSelected = [];
      this.regioesSelected = [];
      this.palletsSelected = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.paramTipoAreaSelected = {
        label: data.paramTipoArea.descr,
        value: data.paramTipoArea.partpareaId,
      };
      if (data.areaRegiao.length > 0) {
        data.areaRegiao.forEach((item, i) => {
          if (item.status.valor == 1) {
            this.regioesSelected.push({
              label: item.regiao.descr,
              value: item.regiao.regiaoId,
              regiao_id: item.regiao.regiaoId,
              status: item.status.valor
            });
          }
        });
      }
      if (data.areaPallet.length > 0) {
        data.areaPallet.forEach((item, i) => {
          if (item.status.valor == 1) {
            this.palletsSelected.push({
              label: item.pallet.cd,
              value: item.pallet.pallet_id,
              pallet_id: item.pallet.pallet_id,
              status: item.status.valor
            });
          }
        });
      }

      if (data.pessoa !== null) {
        this.redespachoSelected = {
          label:
              data.pessoa.pessoaJuridica.razaoSocial +
              "-" +
              this.onFormataCnpj(
                data.pessoa.pessoaJuridica.cnpjBase,
                data.pessoa.pessoaJuridica.cnpjFilial,
                data.pessoa.pessoaJuridica.cnpjDigito
              ),
            value: data.pessoa.pessoaJuridica.pessoaId,
        };
      }

      this.statusLivSelected = {
        label: data.status.descr,
        value: data.status.valor
      };
      this.form.area_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/" + this.rota + "/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getLivStatus() {
      this.helpForm
        .get("/api/area/jsonlistfilters")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.paramTipoArea.forEach((obj) => {
            this.optionsParamTipoArea.push({
              label: obj.descr,
              value: obj.partpareaId,
            });
          });
          response.regiao.forEach((obj) => {
            this.optionsRegiao.push({
              label: obj.descr,
              value: obj.regiaoId,
              regiao_id: obj.regiaoId,
              status: 1
            });
          });
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({
              label: obj.descr,
              value: obj.valor
            });
          });

          response.pallet.forEach((obj) => {
            this.optionsPallet.push({
              label: obj.cd,
              value: obj.pallet_id,
              pallet_id: obj.pallet_id,
              status: 1
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    listaRedespacho(search) {
      if (search.length >= 3) {
        this.isLoadingRedespacho = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsRedespacho = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                if (obj.pessoa.status != 2) {
                  this.optionsRedespacho.push({
                    label:
                      "PJ -" +
                      obj.pessoa.cd +
                      " - " +
                      obj.nome_fantasia +
                      " - " +
                      obj.razao_social +
                      " - " +
                      this.onFormataCnpj(
                        obj.cnpj_base,
                        obj.cnpj_filial,
                        obj.cnpj_digito
                      ) +
                      " - " +
                      obj.inscricao_estadual,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                }
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsRedespacho.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsRedespacho.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingRedespacho = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>